import Vuex, { Module } from 'vuex';
import Vue from 'vue';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { Grid } from '@/models/Grid.model';
import { AdpFileControlModel } from '@/models/backoffice/AdpFileControlModel';
import { RootState } from '@/store';

Vue.use(Vuex);

export interface AdpFileControlState {
  adpFilesErrors: string[];
  adpFilesLoading: boolean;
  adpFileList: Grid<AdpFileControlModel>;
  adpCustomers: Grid;
}

export const initialState = (): AdpFileControlState => {
  return {
    adpFilesErrors: [],
    adpFilesLoading: false,
    adpFileList: {} as Grid<AdpFileControlModel>,
    adpCustomers: {} as Grid,
  };
};

export const adpFiles: Module<AdpFileControlState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};